// Copilot: Create a TanStack Query hook. Strong types for input/output.
// Set staleTime, select shape, error normalization. No UI code; export the hook only.

import { useQuery } from '@tanstack/react-query'

import type { UserDetailsResponse } from '@/utils/api/user-service/models'

import { getCurentUserDetails, getGetCurentUserDetailsQueryKey } from '@/utils/api/user-service'

function toUserSummary(profile: UserDetailsResponse): UserDetailsResponse {
  return {
    id: profile.id,
    firstName: profile.firstName,
    lastName: profile.lastName,
    name: profile.name,
    email: profile.email,
    phoneNumber: profile.phoneNumber,
    // roles: { (profile.roles?.[0] ?? 'ROLE_USER') as any },
    roles: [profile.roles?.[0] ?? 'ROLE_USER' as any],
  }
}

// export async function fetchCurrentUserProfile(authHeader?: string): Promise<UserSummary> {
//   const res = await axios.get<UserDetailsResponse>('/uib-api/user/me', {
//     headers: authHeader ? { Authorization: authHeader } : undefined,
//     withCredentials: false,
//   })
//   return toUserSummary(res.data)
// }

export function useCurrentUserQuery(options?: { enabled?: boolean; staleTime?: number }) {
  const { staleTime = 5 * 60 * 1000, enabled } = options ?? {}

  return useQuery({
    queryKey: getGetCurentUserDetailsQueryKey(),
    queryFn: async () => {
      const res = await getCurentUserDetails()
      return toUserSummary(res.data)
    },
    staleTime,
    enabled,
  })
}

export type { UserDetailsResponse }
